import { useEffect } from 'react';

// Call this in a root component or a custom hook to remove the param after reload
export const useCleanReloadParam = () => {
  useEffect(() => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('cleared')) {
      url.searchParams.delete('cleared');
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }, []);
};